import { Button, Flex, ListsIllustration } from '@cognite/cogs.js-v10';
import type { TFunction } from 'i18next';
import type { FC } from 'react';

import * as S from './elements';

interface Props {
  onBack: () => void;
  onWorkOnChecklist: () => void;
  translationFunction: TFunction;
}

export const TemplateCreatedConfirmationPageUI: FC<Props> = ({
  onBack,
  onWorkOnChecklist,
  translationFunction,
}) => {
  return (
    <S.Container>
      <div>
        <ListsIllustration />
      </div>
      <S.Message>
        {translationFunction(
          'CHECKLIST_CREATED_NEW_CONFIRMATION_MESSAGE',
          'Checklist created. Start the work or go back to the templates list.'
        )}
      </S.Message>
      <Flex gap={8}>
        <Button onClick={onBack}>
          {translationFunction(
            'CHECKLIST_CREATED_NEW_BUTTON_GO_BACK',
            'Go back'
          )}
        </Button>
        <Button size="large" type="primary" onClick={onWorkOnChecklist}>
          {translationFunction(
            'CHECKLIST_CREATED_BUTTON_START_WORK',
            'Start work'
          )}
        </Button>
      </Flex>
    </S.Container>
  );
};
